// windDataCache.js - 风场数据IndexedDB缓存工具

class WindDataCache {
    constructor() {
      this.dbName = 'WindDataDB'
      this.storeName = 'windData'
      this.db = null
    }
  
    // 初始化数据库
    async init() {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(this.dbName, 1)
        
        request.onerror = () => reject(request.error)
        request.onsuccess = () => {
          this.db = request.result
          resolve()
        }
        
        request.onupgradeneeded = (event) => {
          const db = event.target.result
          if (!db.objectStoreNames.contains(this.storeName)) {
            db.createObjectStore(this.storeName)
          }
        }
      })
    }
  
    // 从缓存读取
    async get(key) {
      if (!this.db) await this.init()
      
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([this.storeName], 'readonly')
        const store = transaction.objectStore(this.storeName)
        const request = store.get(key)
        
        request.onsuccess = () => resolve(request.result)
        request.onerror = () => reject(request.error)
      })
    }
  
    // 写入缓存
    async set(key, value) {
      if (!this.db) await this.init()
      
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([this.storeName], 'readwrite')
        const store = transaction.objectStore(this.storeName)
        const request = store.put(value, key)
        
        request.onsuccess = () => resolve()
        request.onerror = () => reject(request.error)
      })
    }
  
    // 清空缓存（可选，调试用）
    async clear() {
      if (!this.db) await this.init()
      
      return new Promise((resolve, reject) => {
        const transaction = this.db.transaction([this.storeName], 'readwrite')
        const store = transaction.objectStore(this.storeName)
        const request = store.clear()
        
        request.onsuccess = () => resolve()
        request.onerror = () => reject(request.error)
      })
    }
  }
  
  // 导出单例
  export default new WindDataCache()